
import axios from 'axios';
import React, { useState } from 'react';
import Navigation from '../components/Navigation';
// import { FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import base_url from '../config/Config';
// import { AiFillFile } from "react-icons/ai";
import Sidebar from '../components/Sidebar';

const AddCustomer = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
                loan_amount: '',
                partner_id: '',
                borrower_name: '',
                father_name: '',
                mobile_number: '',
                emp_id: '',
                fintech_name: '',
                email: '',
                dob: '',
                dob_joining: '',
                gender: '',
                pan_number: '',
                aadhar_number: '',
                pincode: '',
                city: '',
                state: '',
                address: '',
                company_name: '',
                position: '',
                company_address: '',
                professional_email:'',
                salary: '',
                credit_limit: '',
                account_name: '',
                account_number: '',
                ifsc_code: '',
                bank_name: '',
                state_code: '',
                status: '',
                loan_status: '',

    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            console.log('Form Data:', formData);

            // Make an API request to save data
            const response = await axios.post(`${base_url}/api1/customer/addCustomerData`, {
                loanAmount: formData.loan_amount,
                partnerLoanId :formData.partner_id,
                borrowerName: formData.borrower_name,
                fatherName: formData.father_name,
                mobileNumber: formData.mobile_number,
                employeeName:formData.fintech_name,
                email: formData.email,
                dob: formData.dob,
                dobJoining: formData.dob_joining,
                gender: formData.gender,
                empId: formData.emp_id,
                panNumber: formData.pan_number,
                aadharNumber: formData.aadhar_number,
                pinCode: formData.pincode,
                city: formData.city,
                state: formData.state,
                address: formData.address,
                companyName: formData.company_name,
                position: formData.position,
                companyAddress: formData.company_address,
                professionalEmail: formData.professional_email,  
                salary: formData.salary,  
                creditLimit: formData.credit_limit,  
                accountName: formData.account_name,
                accountNumber: formData.account_number,
                ifscCode: formData.ifsc_code,
                bankName: formData.bank_name,
                stateCode: formData.state_code,
                status: formData.status,
                loanStatus:formData.loan_status,
            });

            console.log('API Response:', response.data);

            // Handle the response as needed (e.g., show success message)
            window.alert('Add Customer successfully');

            // Optionally, you can reset the form after successful submission
            setFormData({
                loan_amount: '',
                partner_id: '',
                borrower_name: '',
                father_name: '',
                mobile_number: '',
                emp_id: '',
                fintech_name: '',
                email: '',
                dob: '',
                dob_joining: '',
                gender: '',
                pan_number: '',
                aadhar_number: '',
                pincode: '',
                city: '',
                state: '',
                address: '',
                company_name: '',
                position: '',
                company_address: '',
                professional_email:'',
                salary: '',
                credit_limit: '',
                account_name: '',
                account_number: '',
                ifsc_code: '',
                bank_name: '',
                state_code: '',
                status: '',
                loan_status: '',

            });

            // Redirect to the list page
            navigate('/operation/AllCustomer');
        } catch (error) {
            // Handle errors (e.g., show error message)
            console.error('Error saving data:', error);
        }
    };


    return (
        <>
            <div className='overviewsaa'>
                <h4>Add Customer</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                {/* <hr /> */}
                                {/* Personal Details start  */}
                                
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                        <p>Personal Details</p>
                                    </div>
                                <div className='dashboardlms phonedashbaord mt-3'>
                                <form action="" onSubmit={handleSubmit}>
                                    <div className='row'>
                                        <div className='col-md-12 col-lg-12'>
                                            <div className='personaldetailsinformation mb-3'>
                                           <div className='row mb-5'>
                                           <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="loan_amount">Loan Amount</label> <br />
                                                    <input type="text" name="loan_amount" id="loan_amount" placeholder='Loan Amount' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                             <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="partner_id">Partner Loan Id</label> <br />
                                                    <input type="text" name="partner_id" id="partner_id" placeholder='Partner Loan Id (please enter 8-16 digit)' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="borrower_name">Employee Name</label> <br />
                                                    <input type="text" name="borrower_name" id="borrower_name"   placeholder='Employee Name' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="father_name">Father Name</label> <br />
                                                    <input type="text" name="father_name" id="father_name"   placeholder='Father Name' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                           
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="mobile_number">Phone Number</label><br />
                                                    <input type="text" name="mobile_number" id="mobile_number"  placeholder='Mobile Number' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="fintech_name">Fintech Name</label><br />
                                                    <input type="text" name="fintech_name" id="fintech_name"  placeholder='Fintech Name' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="email">Email</label><br />
                                                    <input type="text" name="email" id="email"   placeholder='Email' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="dob">Date Of Birth</label><br />
                                                    <input type="date" name="dob" id="dob"  placeholder='DOB' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="gender">Gender</label><br />
                                                    <input type="text" name="gender" id="gender" placeholder='Gender' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="dob_joining">Date Of Joining</label><br />
                                                    <input type="date" name="dob_joining" id="dob_joining"  placeholder='Date Of Joining' onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="pan_number"> PAN Number </label><br />
                                                    <input type="text" name="pan_number" id="pan_number"  placeholder='Pan Number' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="aadhar_number"> Aadhar Number </label><br />
                                                    <input type="text" name="aadhar_number" id="aadhar_number"  placeholder='Aadhar Number' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                {/* Personal Details end  */}
                                {/* Resideltal Details start  */}
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify mt-3'>
                                        <p>Address Details</p>
                                    </div>
                                        <div className='row mb-5'>
                                        <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="address">Full Address</label><br />
                                                    <input type="text" name="address" id="address"   placeholder='Address' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                           
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="city">City</label><br />
                                                    <input type="text" name="city" id="city"   placeholder='City' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="state">State Name</label><br />
                                                    <input type="text" name="state" id="state"   placeholder='State Name' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="state_code">State Code</label><br />
                                                    <input type="text" name="state_code" id="state_code"   placeholder='State Code' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="pincode">Pincode</label><br />
                                                    <input type="text" name="pincode" id="pincode"   placeholder='Pincode' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                {/* Resideltal Details end  */}
                                {/* professional details start  */}
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                        <p>Professional Details</p>
                                    </div>
                                        <div className='row mb-5'>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="company_name">Company Name</label> <br />
                                                    <input type="text" name="company_name" id="company_name"   placeholder='Company Name' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="emp_id">Employee Id</label> <br />
                                                    <input type="text" name="emp_id" id="emp_id"   placeholder='Employee Id' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="position">Position </label><br />
                                                    <input type="text" name="position" id="position"   placeholder='Position' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="company_address">Company Address</label><br />
                                                    <input type="text" name="company_address" id="company_address"   placeholder='Company Address' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="professional_email">Professional Email</label><br />
                                                    <input type="email" name="professional_email" id="professional_email"   placeholder='Professional Email' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="salary">Salary/Income</label><br />
                                                    <input type="text" name="salary" id="salary"   placeholder='Salary/Income' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="credit_limit">Credit Limit</label><br />
                                                    <input type="text" name="credit_limit" id="credit_limit"   placeholder='Credit Limit' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                {/* professional details end  */}
                               
                                {/* banking details start  */}
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                        <p>Banking Details</p>
                                    </div>
                                        <div className='row mb-5'>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="account_name">Account Name</label> <br />
                                                    <input type="text" name="account_name" id="account_name" placeholder='Account Name' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="account_number">Account Number</label><br />
                                                    <input type="text" name="account_number" id="account_number"  placeholder='Account Number' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="ifsc_code">IFSC Code </label><br />
                                                    <input type="text" name="ifsc_code" id="ifsc_code"   placeholder='IFSC Code' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="bank_name">Bank Name</label><br />
                                                    <input type="text" name="bank_name" id="bank_name"  placeholder='Bank Name' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                           
                                        </div>
                                </div>
                                {/* Banking details end  */}
                                
                                {/* Beuro details start  */}
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                        <p>Other Details</p>
                                    </div>
                                        <div className='row mb-5'>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="status">Status </label> <br />
                                                    <input type="text" name="status" id="status"  placeholder='Status ' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className='col-md-4 col-lg-4'>
                                                <div className='personaldetails text-justify mt-3'>
                                                    <label htmlFor="loan_status">Loan Status </label> <br />
                                                    <input type="text" name="loan_status" id="loan_status" value=''  placeholder='Loan Status (Null)' onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                {/* Beruo details end  */}
                                  
                                

                                </div>
                                </div>
                                {/* Co-Borrower end  */}
                                
                                <div className='col-md-12 col-lg-12'>
                                                <div className='buttonss mt-5 mb-5 text-center'>
                                                    <button type='submit'>Save</button>
                                                </div>
                                            </div>
                            </div>
                        </div>
                        </form>
                        </div>
                        
                    </div>
                    
                </div>
               
        </div>
        </div>
        </div>
        </div> 
        </>
    );
};

export default AddCustomer;
